import { putProposalReject } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  RejectProposalServiceRequest,
  RejectProposalServiceResponse,
} from './reject-proposal.dto';
import {
  RejectProposalServiceRequestSchema,
  RejectProposalServiceResponseSchema,
} from './reject-proposal.dto';

export const rejectProposalService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(RejectProposalServiceRequestSchema),
    async (request: RejectProposalServiceRequest): Promise<RejectProposalServiceResponse> => {
      const apiResponse = await putProposalReject(request);

      if (apiResponse.meta?.result === 'FAIL') {
        throw new Error(apiResponse.meta?.message ?? '캠페인 제안 거절에 실패했습니다.');
      }

      return apiResponse.data;
    },
    validateServiceResponse(RejectProposalServiceResponseSchema),
  ),
);
